<template>
  <section class="imageModal">
    <p class="image">
      <img :src="dataset.url" />
    </p>
  </section>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'GifAnimationModal',
  props: {
    title: String,
    dataset: Object
  },
  data() {
    return {
      loading: true
    }
  },
  methods: {
    ...mapMutations('modal', ['hideModal'])
  }
}
</script>

<style lang="scss" scoped></style>
